document.addEventListener("DOMContentLoaded", function () {
    const menuItems = document.querySelectorAll(".sf-menu-item-parent");
    
    menuItems.forEach(item => {
        const link = item.querySelector(".sf__parent-item");
        const submenu = item.querySelector(".sf-menu__submenu");

        if (link && submenu) {
            link.addEventListener("click", (event) => {
                event.preventDefault();
                
                // Toggle the visibility of the submenu
                const isOpen = submenu.classList.contains("open");
                
                // Close all open menus first
                document.querySelectorAll(".sf-menu__submenu.open").forEach(menu => {
                    menu.classList.remove("open");
                });

                if (!isOpen) {
                    submenu.classList.add("open");
                }
            });
        }
    });

    // Close menu when clicking outside
    document.addEventListener("click", (event) => {
        if (!event.target.closest(".sf-menu-item-parent")) {
            document.querySelectorAll(".sf-menu__submenu.open").forEach(menu => {
                menu.classList.remove("open");
            });
        }
    });

    // Close menu on ESC key
    document.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
            document.querySelectorAll(".sf-menu__submenu.open").forEach(menu => {
                menu.classList.remove("open");
            });
        }
    });
});


document.querySelectorAll('.umr a.w-full.h-full').forEach(anchor => {
    let span = document.createElement('span'); // Create a new <span> element
    
    // Copy all attributes from <a> to <span>
    for (let attr of anchor.attributes) {
        span.setAttribute(attr.name, attr.value);
    }

    // Copy inner content (text or HTML)
    span.innerHTML = anchor.innerHTML;

    // Replace <a> with <span> in the DOM
    anchor.parentNode.replaceChild(span, anchor);
});

console.log('All <a.w-full.h-full> elements replaced with <span>.');


document.addEventListener("DOMContentLoaded", function () {
    const selectElement = document.querySelector(".collection-selector");

    if (selectElement) {
        
        // Create a label element
        const label = document.createElement("label");
        label.textContent = "Select Collection"; // Set label text
        label.setAttribute("for", "collectionDropdown"); // Associate label with select
        label.style.position = "absolute"; // Hide it visually but keep it accessible
        label.style.width = "1px";
        label.style.height = "1px";
        label.style.overflow = "hidden";
        label.style.clip = "rect(1px, 1px, 1px, 1px)";

        // Set an ID for the select if not already present
        selectElement.id = "collectionDropdown";

        // Insert the label before the select element
        selectElement.parentNode.insertBefore(label, selectElement);
    }
});

//custom 
document.addEventListener('DOMContentLoaded', function () {
    // Add attributes to .shopify-section
    document.querySelectorAll('.shopify-section, .sf-customer-section').forEach((element, index) => {
        element.setAttribute('aria-label', `section(${index + 1})`);
        element.setAttribute('role', 'region');
    });

    // Remove attributes from .footer
    document.querySelectorAll('#shopify-section-footer, .blog-section').forEach(footer => {
        footer.removeAttribute('aria-label');
        footer.removeAttribute('role');
    });

    // Add attributes to #Product-Drawer
    document.querySelectorAll('#Product-Drawer').forEach(drawer => {
        drawer.setAttribute('aria-label', 'section(product drawer)');
        drawer.setAttribute('role', 'region');
    });
});
document.addEventListener("DOMContentLoaded", function () {
    function prependMessage() {
        let selectElement = document.querySelector(".sf__custom-select.w3_bg");
        
        if (selectElement) {
            // Check if the message is already added to avoid duplicates
            if (!selectElement.previousElementSibling || selectElement.previousElementSibling.id !== "a11y-refresh-page-message") {
                let messageSpan = document.createElement("span");
                messageSpan.id = "a11y-refresh-page-message";
                messageSpan.classList.add("visually-hidden"); // Add the visually-hidden class
                messageSpan.textContent = "Page will be refreshed when you select an option";
                
                selectElement.parentNode.insertBefore(messageSpan, selectElement);
                console.log("✅ Message prepended with visually-hidden class before:", selectElement);
            }
        } else {
            console.log("🔄 Select element not found. Retrying...");
            setTimeout(prependMessage, 500); // Keep checking every 500ms until found
        }
    }

    prependMessage();
});
  
document.addEventListener("DOMContentLoaded", function () {
    let select = document.getElementById("collectionDropdown");

    if (!select) {
        console.error("❌ No element found with ID 'collectionDropdown'");
        return;
    }

    // Find all labels associated with this select
    let labels = document.querySelectorAll(`label[for='${select.id}']`);

    console.log(`🔍 Found ${labels.length} labels for #collectionDropdown`);

    if (labels.length === 0) {
        console.warn("⚠️ No label found for #collectionDropdown. Consider adding one.");
    } else if (labels.length > 1) {
        console.warn("⚠️ Multiple labels found! Keeping only the first one.");

        // Keep the first label, remove extra ones
        let firstLabel = labels[0];
        let labelId = firstLabel.id || "collectionLabel";
        firstLabel.id = labelId; // Ensure it has an ID

        // Set aria-labelledby with the correct label
        select.setAttribute("aria-labelledby", labelId);
        console.log(`✅ Assigned aria-labelledby="${labelId}" to #collectionDropdown`);

        // Remove extra labels
        for (let i = 1; i < labels.length; i++) {
            labels[i].remove();
            console.log(`❌ Removed extra label:`, labels[i].textContent);
        }
    } else {
        console.log("✅ Only one label found, no issues detected.");
    }
});

document.addEventListener("DOMContentLoaded", function () {
    function addAriaLabel() {
        let selectElement = document.querySelector(".sf__custom-select.w3_bg select");

        if (selectElement) {
            if (!selectElement.hasAttribute("aria-label")) {
                selectElement.setAttribute("aria-label", "Sort By");
                console.log("✅ Aria-label added to select:", selectElement);
            } else {
                console.log("✅ Aria-label already exists:", selectElement);
            }
        } else {
            console.log("🔄 Select element not found. Retrying...");
            setTimeout(addAriaLabel, 500); // Keep retrying in case the select is loaded later
        }
    }

    addAriaLabel();
});
document.addEventListener("DOMContentLoaded", function () {
    // Find the target container
    let container = document.querySelector('.sf__collection-container.sidebar__leftColumn.w3_bg');
    
    if (container) {
        // Find the select inside the specified structure
        let selectElement = container.querySelector('#CollectionProductGrid .sf__custom-select.w3_bg select');
        
        if (selectElement) {
            // Find the selected option
            let selectedOption = selectElement.querySelector('option[selected="selected"]');
            
            if (selectedOption) {
                // Get the aria-label value from the selected option
                let ariaLabelValue = selectedOption.textContent.trim(); // Use text content as aria-label value
                
                // Set the aria-label attribute on the select element
                selectElement.setAttribute('aria-label', ariaLabelValue);
            }
        }
    }
});
document.addEventListener("DOMContentLoaded", function () {
    // Find the sticky add-to-cart container
    let stickyAtcContainer = document.querySelector('.prod__sticky-atc.sf-prod__block.fixed.z-40.bottom-0.inset-x-0.transition-transform.w3_bg.initialized');

    if (stickyAtcContainer) {
        // Find the input inside form#sticky-atc-form
        let inputElement = stickyAtcContainer.querySelector('form#sticky-atc-form input');

        if (inputElement) {
            // Add aria-label
            inputElement.setAttribute('aria-label', '.');
        }
    }
});
document.addEventListener("DOMContentLoaded", function() {
    var youtubeFrame = document.getElementById("youtube-9519");
    if (youtubeFrame) {
        youtubeFrame.setAttribute("aria-label", "YouTube video");
    }
});
document.addEventListener("DOMContentLoaded", function() {
    var videoBlock = document.querySelector("#video-block-51712359-c03f-4498-9831-bb2bf32903dc iframe");
    if (videoBlock) {
        videoBlock.setAttribute("aria-label", "YouTube video");
    }
});

document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll("h1, h2, h3, h4, h5, h6").forEach(function(heading) {
        if (!heading.textContent.trim()) {
            let span = document.createElement("span");
            heading.replaceWith(span);
        }
    });
});

document.addEventListener("DOMContentLoaded", function() {
    var heading = document.querySelector("#sf-custom-template--18728276623591__165341574489e0d53c h2.section__heading");
    if (heading) {
        heading.setAttribute("aria-level", "1");
    }
});
document.addEventListener("DOMContentLoaded", function() {
    var heading = document.querySelector("section#sf__img-with-text-template--18728276623591__165963105325df8f0b .content__box.w-full.text-left h4");
    if (heading) {
        heading.setAttribute("aria-level", "2");
    }
});

document.addEventListener("DOMContentLoaded", function() {
    function addAriaLevel() {
        var heading = document.querySelector("section#sf__img-with-text-template--18728276623591__1659631427e3b046f9 .content__box.w-full.text-left h4");
        if (heading && !heading.hasAttribute("aria-level")) {
            heading.setAttribute("aria-level", "2");
        }
    }

    // Run immediately if the element is already present
    addAriaLevel();

    // Watch for dynamically loaded elements
    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(addAriaLevel);
    });

    observer.observe(document.body, { childList: true, subtree: true });
});
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("a").forEach(function (link) {
        if (!link.textContent.trim() && !link.getAttribute("aria-label") && !link.querySelector("img")) {
            link.setAttribute("aria-label", "Empty link");
        }
    });
});

document.addEventListener("DOMContentLoaded", function () {
    var sidebar = document.querySelector("ul.sidebar");

    if (sidebar) {
        // Create h2 element first
        var h2 = document.createElement("h2");
        h2.classList.add("visually-hidden");
        h2.textContent = "Heading Text 1";

        // Create h3 element
        var h3 = document.createElement("h3");
        h3.classList.add("visually-hidden");
        h3.textContent = "Heading Text 1";

        // Append h2 first, then h3 after it
        sidebar.prepend(h2);
        h2.insertAdjacentElement("afterend", h3);
    }
});

document.addEventListener("DOMContentLoaded", function () {
    var nameInput = document.getElementById("inputName");
    var emailInput = document.getElementById("inputEmail");
    var messageTextarea = document.getElementById("textareaMessage");

    if (nameInput && !nameInput.hasAttribute("aria-label")) {
        nameInput.setAttribute("aria-label", "First Name");
    }
    
    if (emailInput && !emailInput.hasAttribute("aria-label")) {
        emailInput.setAttribute("aria-label", "Email");
    }
    
    if (messageTextarea && !messageTextarea.hasAttribute("aria-label")) {
        messageTextarea.setAttribute("aria-label", "Enter your message");
    }
});

